import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { LiveSearchResultsGridDataProviderFactory } from '../factory/LiveSearchResultsGridDataProviderFactory';
import LiveSearchGridViewDataProvider from '../dataProvider/LiveSearchResultsGridViewDataProvider';
import { QueryExecution } from '../../types';
import { LiveSearchResultsGridViewData } from '../types';

export default class LiveSearchResultsGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: LiveSearchResultsGridDataProviderFactory;
  public dataProvider: LiveSearchGridViewDataProvider;

  constructor() {
    super();

    this.initialSetup({
      dataProviderFactory: new LiveSearchResultsGridDataProviderFactory(),
    });
  }

  getDataForView(queryExecution: QueryExecution | null): LiveSearchResultsGridViewData {
    return this.dataProvider.getDataForView(queryExecution);
  }
}
